// Furnishing has three states, carried by the API as two booleans: furnished and semi_furnished.
// They are never both true. Each is charged by its own contract rate; semi-furnished's is optional.
export const FURNISHING = {
  NOT_FURNISHED: 'NOT_FURNISHED',
  SEMI_FURNISHED: 'SEMI_FURNISHED',
  FURNISHED: 'FURNISHED',
}

// Null when the realty carries no furnishing information (furnished is null), as legacy ones may
export const toFurnishing = (furnished, semiFurnished) => {
  if (furnished === null || furnished === undefined) return null
  if (furnished) return FURNISHING.FURNISHED
  return semiFurnished ? FURNISHING.SEMI_FURNISHED : FURNISHING.NOT_FURNISHED
}

// No choice (a legacy realty never set) goes as null, which the backend reads as "keep it": sending
// false would count as a furnishing change and recalculate the realty's appointments
export const fromFurnishing = (furnishing) => {
  if (!furnishing) return { furnished: null, semi_furnished: null }

  return {
    furnished: furnishing === FURNISHING.FURNISHED,
    semi_furnished: furnishing === FURNISHING.SEMI_FURNISHED,
  }
}

export const furnishingKey = (realty) => {
  const furnishing = toFurnishing(realty?.furnished, realty?.semi_furnished)
  return furnishing ? `realty.furnishing.${furnishing}` : null
}

export const furnishingOptions = (translate) =>
  Object.values(FURNISHING).map((value) => ({
    value,
    name: translate(`realty.furnishing.${value}`),
  }))
